// src/App.jsx - ИСПРАВЛЕННАЯ ВЕРСИЯ
import React, { useEffect } from "react";
import { Admin, Resource, useDataProvider } from "react-admin";
import { UserList } from "./users";
import { MessagesList } from './messages';
import { authProvider } from "./authProvider";
import dataProvider from './dataProvider';



function App() {
  console.log("🎬 Rendering App component...");
  
  return (
    <Admin
      dataProvider={dataProvider}
      authProvider={authProvider}
      // Добавляем dashboard для видимости
      dashboard={() => (
        <div style={{ padding: 20 }}>
          <h2>Админ-панель</h2>
          <p>Перейдите в раздел <strong>Messages</strong> в меню слева</p>
        </div>
      )}
    >
      
      <Resource 
          name="messages" 
          list={MessagesList} 
          icon={() => <span style={{ fontSize: '1.2em' }}>🗳️</span>}
          options={{ label: 'Сообщения' }}
      />
      
    </Admin>
  );
}

export default App;